define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/heading/RendererStoreMixin",
	"csi/xml",
	"Apparel/MaterialRefMixin",
	"Specification/BOM/BOMSectionMixin"
], function(declare,Ref,RendererStoreMixin,xml,MaterialRefMixin,BOMSectionMixin) {

	return declare([Ref, RendererStoreMixin, MaterialRefMixin, BOMSectionMixin], {
		// only Materials ok for Style BOM can be selected on Theme, which will include constraints on Structured Components and Tools
		_bForStyleBOM: true,

		_addFilters: function(/*Context*/ctx, /*Query*/q) {
			// summary: return filters for BOMSection Material Types
			this.inherited(arguments);

			if (ctx.getNode()) {
				this.applyBomSectionQuery(ctx.getNode().DSSection, q, ctx.cache);
			}
		},

		getCustomStoreKey: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			// summary: Fix the drop-down cache issue of the Products to include BOM section
			return ctx.getNode().DSSection;
		}

	});
});